module.exports = __webpack_public_path__ + "img/resource-tech-image-69.1691a099.jpg";